<template>
  <div
    class="wrapper"
    :class="{
      disabled: isSetConfigSource,
    }"
  >
    <div
      v-if="isSetConfigSource"
      class="cover"
    />
    <div class="header flex center gaps">
      <div class="box">
        <h3 class="heading no-margin">
          {{ !isSetConfigSource ? "自由項目を設定する" : "共有された自由項目" }}
        </h3>
      </div>
      <div class="box grow" />
      <div
        v-if="!isSetConfigSource"
        class="box"
      >
        <el-button
          size="small"
          plain
          :disabled="isDisabledAddItem"
          @click="$emit('showAddItemDialog')"
        >
          自由項目を追加
        </el-button>
      </div>
    </div>

    <div
      v-if="customFields.length"
      class="items"
    >
      <template v-for="(item, index) in customFields">
        <!-- 自由項目における各タイプのコンポーネントを表示する -->
        <component
          :is="computedComponentName(item)"
          :item="item"
          :index="index"
          :is-set-config-source="isSetConfigSource"
          :key="`customFields-${item.customFieldNumber}`"
          @deleteItem="deleteItem"
        />
      </template>
    </div>

    <div
      v-else
      class="items"
    >
      自由項目の登録がありません
    </div>

    <div class="actions flex center gaps">
      <div class="box">
        <!-- 自由項目の登録数と上限を表示する -->
        <small>{{ informationOnNumberOfItems }}</small>
      </div>
      <div class="box grow" />
      <div class="box">
        <el-button
          v-if="!isSetConfigSource"
          type="primary"
          size="small"
          @click="$emit('updateCustomFields')"
        >
          保 存
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdminOrderCustomFieldItemsText from "@/components/Admin/OrderCustomField/Items/Text.vue";
import AdminOrderCustomFieldItemsTextList from "@/components/Admin/OrderCustomField/Items/TextList.vue";
import AdminOrderCustomFieldItemsInt from "@/components/Admin/OrderCustomField/Items/Int.vue";
import AdminOrderCustomFieldItemsFloat from "@/components/Admin/OrderCustomField/Items/Float.vue";
import AdminOrderCustomFieldItemsDate from "@/components/Admin/OrderCustomField/Items/Date.vue";

const COMPONENT_TYPES = [
  {
    type: "TEXT",
    component: "AdminOrderCustomFieldItemsText",
  },
  {
    type: "TEXT_LIST",
    component: "AdminOrderCustomFieldItemsTextList",
  },
  {
    type: "INT",
    component: "AdminOrderCustomFieldItemsInt",
  },
  {
    type: "FLOAT",
    component: "AdminOrderCustomFieldItemsFloat",
  },
  {
    type: "DATE",
    component: "AdminOrderCustomFieldItemsDate",
  },
];

const MAXIMUM_NUMBER_OF_ITEMS = 20;

export default {
  name: "AdminOrderCustomFieldConfig",
  components: {
    AdminOrderCustomFieldItemsText,
    AdminOrderCustomFieldItemsTextList,
    AdminOrderCustomFieldItemsInt,
    AdminOrderCustomFieldItemsFloat,
    AdminOrderCustomFieldItemsDate,
  },
  props: {
    customFields: Array,
    isSetConfigSource: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
    isDisabledAddItem () {
      const { customFields } = this;

      return customFields.length >= MAXIMUM_NUMBER_OF_ITEMS;
    },

    informationOnNumberOfItems () {
      const { customFields } = this;

      return `登録数: ${customFields.length} / ${MAXIMUM_NUMBER_OF_ITEMS}`;
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    computedComponentName (item) {
      const target = COMPONENT_TYPES.find((_item) => _item.type === item.type);

      if (target) {
        return target.component;
      }
    },

    deleteItem (index) {
      if (!window.confirm("項目を削除してもよろしいですか？")) {
        return;
      }

      this.customFields.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.wrapper {
  position: relative;
  margin: 12px 15px 15px;
  // background-color: $background-gray-light;
  // border-radius: 8px;

  &.disabled {
    filter: grayscale(100);
  }

  .cover {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
  }

  .header {
    position: sticky;
    top: 0;
    padding: 12px 15px;
    background-color: white;
    // background-color: $background-gray-light;
    // border-radius: 8px 8px 0 0;
    z-index: 2;

    .heading {
      margin-block-start: 0;
      margin-block-end: 12px;

      &.no-margin {
        margin-block-end: 0;
      }
    }
  }

  .items {
    padding: 0px 15px;
  }

  .actions {
    position: sticky;
    bottom: 0px;
    padding: 12px 15px;
    background-color: white;
    // background-color: $background-gray-light;
    // border-radius: 0 0 8px 8px;
    z-index: 1;
  }
}
</style>
